module.exports = {
  OPEN: 'open',
  CLOSED: 'closed',
};
